import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { LocalizedRouterLinkPipe } from '@core/i18n/localized-router-link.pipe';

/**
 * Banner promocional (gradiente) no rodapé das páginas, equivalente ao
 * `PromoBanner` do PageLayout do protótipo. Todos os textos são chaves i18n.
 */
@Component({
  selector: 'app-promo-banner',
  standalone: true,
  imports: [RouterLink, TranslocoPipe, LocalizedRouterLinkPipe],
  template: `
    <section class="mt-16">
      <div
        class="relative overflow-hidden rounded-3xl bg-gradient-arp px-8 py-12 text-center text-white shadow-elevated md:px-12 md:py-14"
      >
        <div
          aria-hidden="true"
          class="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-white/5 blur-2xl"
        ></div>
        <div
          aria-hidden="true"
          class="pointer-events-none absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-primary/20 blur-3xl"
        ></div>

        <div class="relative">
          <p class="mb-3 eyebrow-on-dark">{{ eyebrowKey() | transloco }}</p>
          <h2 class="font-display text-2xl font-bold leading-tight md:text-3xl">
            <span class="text-white">{{ titlePrefixKey() | transloco }}</span>
            <span class="italic text-primary-glow">{{ titleAccentKey() | transloco }}</span>
          </h2>
          <p
            class="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-white/75 md:text-base"
          >
            {{ descriptionKey() | transloco }}
          </p>
          <div class="mt-7">
            <a [routerLink]="ctaPath() | localizedRouterLink" class="btn-pill btn-pill--primary">
              {{ ctaLabelKey() | transloco }}
              <svg
                aria-hidden="true"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="h-4 w-4"
              >
                <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  `,
})
export class PromoBannerComponent {
  readonly eyebrowKey = input.required<string>();
  readonly titlePrefixKey = input.required<string>();
  readonly titleAccentKey = input.required<string>();
  readonly descriptionKey = input.required<string>();
  readonly ctaLabelKey = input.required<string>();
  readonly ctaPath = input.required<string>();
}
